{
  "PROFILE_SETTINGS": {
    "LINK": "Nastavitve profila",
    "TITLE": "Nastavitve profila",
    "BTN_TEXT": "Posodobi profil",
    "DELETE_AVATAR": "Izbriši avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar je bil uspešno izbrisan",
    "AVATAR_DELETE_FAILED": "Pri brisanju avatarja je prišlo do napake, prosimo, poskusite znova",
    "UPDATE_SUCCESS": "Vaš profil je bil uspešno posodobljen",
    "PASSWORD_UPDATE_SUCCESS": "Vaše geslo je bilo uspešno spremenjeno",
    "AFTER_EMAIL_CHANGED": "Vaš profil je bil uspešno posodobljen, prosimo, da se ponovno prijavite, saj so se vaše prijavne podatke spremenile",
    "FORM": {
      "PICTURE": "Profilna slika",
      "AVATAR": "Slika profila",
      "ERROR": "Prosimo, odpravite napake v obrazcu",
      "REMOVE_IMAGE": "Odstrani",
      "UPLOAD_IMAGE": "Naloži sliko",
      "UPDATE_IMAGE": "Posodobi sliko",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Vaš e-poštni naslov je vaša identiteta in se uporablja za prijavo."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hitri gumb za pošiljanje sporočil",
        "NOTE": "Lahko izberete bližnjico (Enter ali Cmd/Ctrl+Enter) glede na vašo željo pisanja.",
        "UPDATE_SUCCESS": "Vaše nastavitve so bile uspešno posodobljene",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Vnesi (↵)",
            "CONTENT": "Pošljite sporočila s pritiskom tipke Enter namesto s klikom na gumb za pošiljanje."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Vnesi (⌘ + ↵)",
            "CONTENT": "Pošiljajte sporočila s pritiskom na Cmd/Ctrl + enter namesto s klikom na gumb za pošiljanje."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Vmesnik",
        "NOTE": "Prilagodite videz in občutek vaše nadzorne plošče Chatwoot.",
        "FONT_SIZE": {
          "TITLE": "Velikost pisave",
          "NOTE": "Prilagodite velikost besedila po celotni nadzorni plošči glede na vaše želje.",
          "UPDATE_SUCCESS": "Nastavitve pisave so bile uspešno posodobljene",
          "UPDATE_ERROR": "Pri posodabljanju nastavitev pisave je prišlo do napake, prosimo, poskusite znova",
          "OPTIONS": {
            "SMALLER": "Manjše",
            "SMALL": "Majhno",
            "DEFAULT": "Privzeto",
            "LARGE": "Veliko",
            "LARGER": "Večje",
            "EXTRA_LARGE": "Zelo veliko"
          }
        },
        "LANGUAGE": {
          "TITLE": "Želeni jezik",
          "NOTE": "Izberite jezik, ki ga želite uporabljati.",
          "UPDATE_SUCCESS": "Nastavitve jezika so bile uspešno posodobljene",
          "UPDATE_ERROR": "Pri posodabljanju nastavitev jezika je prišlo do napake, prosimo, poskusite znova",
          "USE_ACCOUNT_DEFAULT": "Uporabi privzeto nastavitev računa"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Osebni podpis sporočila",
        "NOTE": "Ustvarite edinstven podpis sporočila, ki se bo prikazal na koncu vsakega sporočila, ki ga pošljete iz katerega koli nabiralnika. Vključite lahko tudi vstavno sliko, ki je podprta v klepetu v živo, e-pošti in API nabiralnikih.",
        "BTN_TEXT": "Shrani podpis sporočila",
        "API_ERROR": "Podpisa ni bilo mogoče shraniti! Poskusi znova",
        "API_SUCCESS": "Podpis je bil uspešno shranjen",
        "IMAGE_UPLOAD_ERROR": "Slike ni bilo mogoče naložiti! Poskusi znova",
        "IMAGE_UPLOAD_SUCCESS": "Slika je bila uspešno dodana. Za shranitev podpisa kliknite na shrani",
        "IMAGE_UPLOAD_SIZE_ERROR": "Velikost slike mora biti manjša od {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Podpis sporočila",
        "ERROR": "Podpis sporočila ne sme biti prazen",
        "PLACEHOLDER": "Vnesite svoj osebni podpis sporočila tukaj."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Geslo",
        "NOTE": "Posodobitev gesla bo ponastavila prijave na več napravah.",
        "BTN_TEXT": "Spremeni geslo"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Dostopni žeton",
        "NOTE": "Ta žeton lahko uporabite, če ustvarjate integracijo na osnovi API-ja",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "Kopiraj",
        "RESET": "Ponastavi",
        "CONFIRM_RESET": "Ste prepričani?",
        "CONFIRM_HINT": "Kliknite še enkrat za potrditev",
        "RESET_SUCCESS": "Dostopni žeton je bil uspešno ponovno ustvarjen",
        "RESET_ERROR": "Ni bilo mogoče ponovno ustvariti dostopnega žetona. Poskusite znova"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Zvočni opozorili",
        "NOTE": "Omogočite zvočna opozorila v nadzorni plošči za nova sporočila in pogovore.",
        "PLAY": "Predvajaj zvok",
        "ALERT_TYPES": {
          "NONE": "Brez",
          "MINE": "Dodeljeno",
          "ALL": "Vse",
          "ASSIGNED": "Moji dodeljeni pogovori",
          "UNASSIGNED": "Nedodeljeni pogovori",
          "NOTME": "Odprti pogovori, dodeljeni drugim"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Niste izbrali nobene možnosti, ne boste prejeli nobenih zvočnih opozoril.",
          "ASSIGNED": "Prejeli boste opozorila za pogovore, dodeljene vam.",
          "UNASSIGNED": "Prejeli boste opozorila za vse nepodeljene pogovore.",
          "NOTME": "Prejeli boste opozorila za pogovore, dodeljene drugim.",
          "ASSIGNED+UNASSIGNED": "Prejeli boste opozorila za vaše dodeljene pogovore in vse nepazljene.",
          "ASSIGNED+NOTME": "Prejeli boste opozorila za pogovore, dodeljene vam in drugim, ne pa za nepodeljene.",
          "NOTME+UNASSIGNED": "Prejeli boste opozorila za neodzveto pogovore in tiste, dodeljene drugim.",
          "ASSIGNED+NOTME+UNASSIGNED": "Prejeli boste opozorila za vse pogovore."
        },
        "ALERT_TYPE": {
          "TITLE": "Dogodki opozoril za pogovore",
          "NONE": "Brez",
          "ASSIGNED": "Dodeljeni pogovori",
          "ALL_CONVERSATIONS": "Vsi pogovori"
        },
        "DEFAULT_TONE": {
          "TITLE": "Zvok opozorila:"
        },
        "CONDITIONS": {
          "TITLE": "Pogoji za opozorila:",
          "CONDITION_ONE": "Pošiljaj zvočna opozorila samo, če okno brskalnika ni aktivno",
          "CONDITION_TWO": "Pošiljaj opozorila vsakih trideset sekund, dokler niso prebrani vsi dodeljeni pogovori"
        },
        "SOUND_PERMISSION_ERROR": "Samodejno predvajanje je v vašem brskalniku onemogočeno. Če želite samodejno slišati opozorila, omogočite dovoljenje za zvok v nastavitvah brskalnika ali pa interagirajte s stranjo.",
        "READ_MORE": "Preberite več"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-poštna obvestila",
        "NOTE": "Tukaj posodobite nastavitve obvestil po e-pošti",
        "CONVERSATION_ASSIGNMENT": "Pošlji obvestila po e-pošti, ko mi je dodeljen pogovor",
        "CONVERSATION_CREATION": "Pošlji obvestila po e-pošti, ko je ustvarjen nov pogovor",
        "CONVERSATION_MENTION": "Pošlji e-poštna obvestila, ko si omenjen v pogovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Pošlji e-poštna obvestila, ko je v dodeljenem pogovoru ustvarjeno novo sporočilo",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Pošlji e-poštna obvestila, ko je v sodelujočem pogovoru ustvarjeno novo sporočilo",
        "SLA_MISSED_FIRST_RESPONSE": "Pošlji e-poštna obvestila, ko pogovor ne doseže SLA za prvi odgovor",
        "SLA_MISSED_NEXT_RESPONSE": "Pošlji e-poštna obvestila, ko pogovor ne doseže SLA za naslednji odgovor",
        "SLA_MISSED_RESOLUTION": "Pošlji e-poštna obvestila, ko pogovor ne doseže SLA za rešitev"
      },
      "NOTIFICATIONS": {
        "TITLE": "Nastavitve obvestil",
        "TYPE_TITLE": "Vrsta obvestila",
        "EMAIL": "E-pošta",
        "PUSH": "Potisno obvestilo",
        "TYPES": {
          "CONVERSATION_CREATED": "Ustvari se nov pogovor",
          "CONVERSATION_ASSIGNED": "Pogovor je dodeljen vam",
          "CONVERSATION_MENTION": "Omenjeni ste v pogovoru",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "V dodeljenem pogovoru je ustvarjeno novo sporočilo",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "V sodelujočem pogovoru je ustvarjeno novo sporočilo",
          "SLA_MISSED_FIRST_RESPONSE": "Pogovor ni izpolnil SLA za prvi odgovor",
          "SLA_MISSED_NEXT_RESPONSE": "Pogovor ni izpolnil SLA za naslednji odgovor",
          "SLA_MISSED_RESOLUTION": "Pogovor ni izpolnil SLA za rešitev"
        },
        "BROWSER_PERMISSION": "Omogočite potisna obvestila za vaš brskalnik, da jih boste lahko prejemali"
      },
      "API": {
        "UPDATE_SUCCESS": "Vaše nastavitve obvestil so bile uspešno posodobljene",
        "UPDATE_ERROR": "Pri posodabljanju nastavitev je prišlo do napake, prosimo, poskusite znova"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Potisna obvestila",
        "NOTE": "Tukaj posodobite nastavitve potisnih obvestil",
        "CONVERSATION_ASSIGNMENT": "Pošlji potisna obvestila, ko je pogovor dodeljen meni",
        "CONVERSATION_CREATION": "Pošlji potisna obvestila, ko je ustvarjen nov pogovor",
        "CONVERSATION_MENTION": "Pošlji potisna obvestila, ko si omenjen v pogovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Pošlji potisna obvestila, ko je v dodeljenem pogovoru ustvarjeno novo sporočilo",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Pošlji potisna obvestila, ko je v sodelujočem pogovoru ustvarjeno novo sporočilo",
        "HAS_ENABLED_PUSH": "Za ta brskalnik ste omogočili potisna obvestila.",
        "REQUEST_PUSH": "Omogoči potisna obvestila",
        "SLA_MISSED_FIRST_RESPONSE": "Pošlji potisna obvestila, ko pogovor ne doseže SLA za prvi odgovor",
        "SLA_MISSED_NEXT_RESPONSE": "Pošlji potisna obvestila, ko pogovor ne doseže SLA za naslednji odgovor",
        "SLA_MISSED_RESOLUTION": "Pošlji potisna obvestila, ko pogovor ne doseže SLA za rešitev"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilna slika"
      },
      "NAME": {
        "LABEL": "Vaše polno ime",
        "ERROR": "Prosimo, vnesite veljavno polno ime",
        "PLACEHOLDER": "Prosimo, vnesite svoje polno ime"
      },
      "DISPLAY_NAME": {
        "LABEL": "Prikazno ime",
        "ERROR": "Prosimo, vnesite veljavno prikazno ime",
        "PLACEHOLDER": "Prosimo, vnesite prikazno ime, ki bo prikazano v pogovorih"
      },
      "AVAILABILITY": {
        "LABEL": "Razpoložljivost",
        "STATUS": {
          "ONLINE": "Na spletu",
          "BUSY": "Zaseden",
          "OFFLINE": "Brez povezave"
        },
        "SET_AVAILABILITY_SUCCESS": "Razpoložljivost je bila uspešno nastavljena",
        "SET_AVAILABILITY_ERROR": "Nastavitve razpoložljivosti ni bilo mogoče shraniti, prosimo, poskusite znova",
        "IMPERSONATING_ERROR": "Ni mogoče spremeniti razpoložljivosti med prevzemanjem uporabnika"
      },
      "EMAIL": {
        "LABEL": "Vaš e-poštni naslov",
        "ERROR": "Prosimo, vnesite veljaven e-poštni naslov",
        "PLACEHOLDER": "Prosimo, vnesite svoj e-poštni naslov, ta bo prikazan v pogovorih"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Trenutno geslo",
        "ERROR": "Prosimo, vnesite trenutno geslo",
        "PLACEHOLDER": "Prosimo, vnesite trenutno geslo"
      },
      "PASSWORD": {
        "LABEL": "Novo geslo",
        "ERROR": "Prosimo, vnesite geslo dolžine 6 ali več znakov",
        "PLACEHOLDER": "Prosimo, vnesite novo geslo"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potrdite novo geslo",
        "ERROR": "Potrditev gesla se mora ujemati z geslom",
        "PLACEHOLDER": "Prosimo, ponovno vnesite novo geslo"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Spremeni",
    "CHANGE_ACCOUNTS": "Preklopi račun",
    "SWITCH_ACCOUNT": "Zamenjaj račun",
    "CONTACT_SUPPORT": "Kontaktirajte podporo",
    "SELECTOR_SUBTITLE": "Izberite račun s spodnjega seznama",
    "PROFILE_SETTINGS": "Nastavitve profila",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Bližnjice na tipkovnici",
    "APPEARANCE": "Spremeni videz",
    "SUPER_ADMIN_CONSOLE": "Konzola SuperAdmin",
    "DOCS": "Preberite dokumentacijo",
    "CHANGELOG": "Zapisnik sprememb",
    "LOGOUT": "Odjava"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dni preizkusne dobe je še na voljo.",
    "TRAIL_BUTTON": "Kupi zdaj",
    "DELETED_USER": "Izbrisani uporabnik",
    "EMAIL_VERIFICATION_PENDING": "Zdi se, da svojega e-poštnega naslova še niste potrdili. Prosimo, preverite svoj nabiralnik za potrditveno sporočilo.",
    "RESEND_VERIFICATION_MAIL": "Ponovno pošlji potrditveni e-poštni naslov",
    "EMAIL_VERIFICATION_SENT": "Potrditveni e-poštni naslov je bil poslan. Prosimo, preverite svoj poštni predal.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Račun je začasno onemogočen",
      "MESSAGE": "Vaš račun je začasno onemogočen. Za več informacij se obrnite na podporno ekipo."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Log out"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiraj",
      "CODEPEN": "Odpri v CodePen",
      "COPY_SUCCESSFUL": "Kopirano v odložišče"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Pokaži več",
      "SHOW_LESS": "Pokaži manj"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Prenesi",
      "UPLOADING": "Nalaganje...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ta zgodba ni več na voljo.",
      "INSTAGRAM_STORY_REPLY": "Replied to your story:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Poglej na zemljevidu"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Pošlji"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Ta slika ni več na voljo.",
      "LOADING_FAILED": "Nalaganje ni uspelo"
    }
  },
  "CONFIRM_EMAIL": "Preverjanje poteka...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Dodaj poštni predal"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Brez elementov",
    "CURRENTLY_VIEWING_ACCOUNT": "Trenutno gledate:",
    "SWITCH": "Preklopi",
    "INBOX_VIEW": "Pogled Prejeto",
    "CONVERSATIONS": "Pogovori",
    "INBOX": "Moja pošta",
    "ALL_CONVERSATIONS": "Vsi pogovori",
    "MENTIONED_CONVERSATIONS": "Omenjanja",
    "PARTICIPATING_CONVERSATIONS": "Sodelovanje",
    "UNATTENDED_CONVERSATIONS": "Neposredovano",
    "REPORTS": "Poročila",
    "SETTINGS": "Nastavitve",
    "CONTACTS": "Stiki",
    "ACTIVE": "Aktivno",
    "COMPANIES": "Companies",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Kapitan",
    "CAPTAIN_ASSISTANTS": "Pomočniki",
    "CAPTAIN_OVERVIEW": "Pregled",
    "CAPTAIN_DOCUMENTS": "Dokumenti",
    "CAPTAIN_RESPONSES": "Pogosta vprašanja",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Inboxes",
    "CAPTAIN_SETTINGS": "Settings",
    "HOME": "Domov",
    "AGENTS": "Agentje",
    "AGENT_BOTS": "Boti",
    "AUDIT_LOGS": "Revizijski zapisi",
    "INBOXES": "Prejemniki",
    "NOTIFICATIONS": "Obvestila",
    "CANNED_RESPONSES": "Vnaprej pripravljeni odgovori",
    "INTEGRATIONS": "Integracije",
    "DATA": "Data",
    "PROFILE_SETTINGS": "Nastavitve profila",
    "ACCOUNT_SETTINGS": "Nastavitve računa",
    "APPLICATIONS": "Aplikacije",
    "LABELS": "Oznake",
    "CUSTOM_ATTRIBUTES": "Lastni atributi",
    "AUTOMATION": "Avtomatizacija",
    "MACROS": "Makri",
    "TEAMS": "Ekipe",
    "BILLING": "Računovodstvo",
    "CUSTOM_VIEWS_FOLDER": "Mape",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Vsi stiki",
    "TAGGED_WITH": "Označeno z",
    "NEW_LABEL": "Nova oznaka",
    "NEW_TEAM": "Nova ekipa",
    "NEW_INBOX": "Nov poštni predal",
    "REPORTS_CONVERSATION": "Pogovori",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Pogovor v živo",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Kampanje",
    "ONGOING": "V teku",
    "ONE_OFF": "Enkratno",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Boti",
    "REPORTS_AGENT": "Agentje",
    "REPORTS_LABEL": "Oznake",
    "REPORTS_INBOX": "Prejeto",
    "REPORTS_TEAM": "Ekipa",
    "AGENT_ASSIGNMENT": "Dodeljevanje agentov",
    "SET_AVAILABILITY_TITLE": "Nastavi se kot",
    "SET_YOUR_AVAILABILITY": "Nastavite svojo razpoložljivost",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Prilagojene vloge",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pregled",
    "REAUTHORIZE": "Povezava z vašim poštnim predalom je potekla, prosimo, ponovno se povežite\n da boste lahko nadaljevali s prejemanjem in pošiljanjem sporočil",
    "HELP_CENTER": {
      "TITLE": "Pomoč",
      "ARTICLES": "Članki",
      "CATEGORIES": "Kategorije",
      "LOCALES": "Jeziki",
      "SETTINGS": "Nastavitve"
    },
    "CHANNELS": "Kanali",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Samodejno označi kot nedosegljiv",
      "INFO_TEXT": "Dovoli sistemu, da te samodejno označi kot nedosegljivega, ko ne uporabljaš aplikacije ali nadzorne plošče.",
      "INFO_SHORT": "Samodejno označi kot nedosegljiv, ko aplikacije ne uporabljaš."
    },
    "SORT_TOOLTIP": "Sort",
    "SORT_BY": "Razvrsti po",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Preberite dokumentacijo",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Uvozi",
      "EXPORT": "Izvozi"
    },
    "TYPES": {
      "CONTACTS": "Stiki",
      "CONVERSATIONS": "Conversations",
      "MESSAGES": "Messages"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "Cancel",
      "IMPORT": "Uvozi"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Uvozi",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "Name",
      "TYPE": "Type",
      "STATUS": "Status",
      "IMPORTED": "Imported",
      "CREATED": "Ustvarjeno",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Ustvarjeno",
      "DURATION": "Duration",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "All",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "Sporočilo"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "Refresh",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "Completed",
        "completed_with_errors": "Completed with errors",
        "failed": "Neuspešno",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Features",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Računovodstvo",
    "DESCRIPTION": "Tukaj upravljajte svojo naročnino, nadgradite svoj načrt in pridobite več za svojo ekipo.",
    "CURRENT_PLAN": {
      "TITLE": "Trenutni načrt",
      "PLAN_NOTE": "Trenutno ste naročeni na načrt **{plan}** z **{quantity}** licencami",
      "SEAT_COUNT": "Število mest",
      "RENEWS_ON": "Obnavlja se dne",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "Ogled cen",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Upravljajte svoje naročnino",
      "DESCRIPTION": "Ogledate si lahko pretekle račune, uredite podatke za obračunavanje ali prekličete naročnino.",
      "BUTTON_TXT": "Pojdi na portal za obračunavanje"
    },
    "CAPTAIN": {
      "TITLE": "Kapitan",
      "DESCRIPTION": "Upravljajte uporabo in kredite za Captain AI.",
      "BUTTON_TXT": "Kupite več kreditov",
      "DOCUMENTS": "Dokumenti",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain ni na voljo v brezplačnem paketu, nadgradite zdaj za dostop do pomočnikov, kopilota in več.",
      "REFRESH_CREDITS": "Refresh"
    },
    "CHAT_WITH_US": {
      "TITLE": "Potrebujete pomoč?",
      "DESCRIPTION": "Imate težave z obračunavanjem? Tu smo, da pomagamo.",
      "BUTTON_TXT": "Klepetajte z nami"
    },
    "NO_BILLING_USER": "Vaš račun za obračunavanje se ureja. Prosimo, osvežite stran in poskusite znova.",
    "TOPUP": {
      "BUY_CREDITS": "Buy more credits",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Note:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Cancel",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Pojdi nazaj",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "Copied to clipboard",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Search attributes"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Resolve conversation",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Resolve conversation",
          "CANCEL": "Cancel"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Select an option"
        },
        "CHECKBOX": {
          "YES": "Yes",
          "NO": "No"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ojej! Nismo našli nobenega Chatwoot računa. Za nadaljevanje ustvarite nov račun.",
    "NEW_ACCOUNT": "Nov račun",
    "SELECTOR_SUBTITLE": "Ustvarite nov račun",
    "API": {
      "SUCCESS_MESSAGE": "Račun je bil uspešno ustvarjen",
      "EXIST_MESSAGE": "Račun že obstaja",
      "ERROR_MESSAGE": "Povezava s strežnikom Woot ni uspela, prosimo, poskusite znova kasneje"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Ime podjetja",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Pošlji",
      "CANCEL": "Prekliči"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Prikaži vse bližnjice",
    "TITLE": {
      "OPEN_CONVERSATION": "Odpri pogovor",
      "RESOLVE_AND_NEXT": "Reši in pojdi na naslednjega",
      "NAVIGATE_DROPDOWN": "Premikaj se po elementih spustnega seznama",
      "RESOLVE_CONVERSATION": "Reši pogovor",
      "GO_TO_CONVERSATION_DASHBOARD": "Pojdi na nadzorno ploščo pogovorov",
      "ADD_ATTACHMENT": "Dodaj priponko",
      "GO_TO_CONTACTS_DASHBOARD": "Pojdi na nadzorno ploščo stikov",
      "TOGGLE_SIDEBAR": "Preklopi stransko vrstico",
      "GO_TO_REPORTS_SIDEBAR": "Pojdi na stransko vrstico poročil",
      "MOVE_TO_NEXT_TAB": "Premakni se na naslednjo zavihek v seznamu pogovorov",
      "GO_TO_SETTINGS": "Pojdi na Nastavitve",
      "SWITCH_TO_PRIVATE_NOTE": "Preklopi na zasebno opombo",
      "SWITCH_TO_REPLY": "Preklopi na odgovor",
      "TOGGLE_SNOOZE_DROPDOWN": "Preklopi spustni meni za odlog"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Dodeljevanje agentov",
        "DESCRIPTION": "Določite pravila za učinkovito upravljanje delovne obremenitve in usmerjanje pogovorov glede na potrebe prejemnikov in agentov. Več informacij tukaj"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Pravila dodeljevanja",
        "DESCRIPTION": "Upravljajte, kako se pogovori dodeljujejo v prejemnih mapah.",
        "FEATURES": [
          "Dodeljujte pogovore enakomerno ali glede na razpoložljivo zmogljivost",
          "Dodajte pravila poštene razporeditve, da preprečite preobremenitev katerega koli agenta",
          "Dodajte prejemne mape k pravilu – eno pravilo na prejemno mapo"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Pravila zmogljivosti agentov",
        "DESCRIPTION": "Upravljajte delovno obremenitev agentov.",
        "FEATURES": [
          "Določite največje število pogovorov na prejemno pošto",
          "Ustvarite izjeme na podlagi oznak in časa",
          "Dodajte agente v pravilo – eno pravilo na agenta"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Pravila dodeljevanja",
          "CREATE_POLICY": "Novo pravilo"
        },
        "CARD": {
          "ORDER": "Vrstni red",
          "PRIORITY": "Prioriteta",
          "ACTIVE": "Aktivno",
          "INACTIVE": "Neaktivno",
          "POPOVER": "Dodani predali",
          "EDIT": "Uredi"
        },
        "NO_RECORDS_FOUND": "Ni najdenih pravil dodeljevanja"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Ustvari pravilo dodeljevanja"
        },
        "CREATE_BUTTON": "Ustvari pravilo",
        "API": {
          "SUCCESS_MESSAGE": "Pravilo dodeljevanja je bilo uspešno ustvarjeno",
          "ERROR_MESSAGE": "Ustvarjanje pravila dodeljevanja ni uspelo",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Uredi pravilo dodeljevanja"
        },
        "EDIT_BUTTON": "Posodobi pravilo",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Dodaj poštni predal",
          "DESCRIPTION": "Poštni predal {inboxName} je že povezan z drugim pravilom. Ste prepričani, da ga želite povezati s tem pravilom? Povezava z drugim pravilom bo prekinjena.",
          "CONFIRM_BUTTON_LABEL": "Nadaljuj",
          "CANCEL_BUTTON_LABEL": "Prekliči"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Pravilnik o dodelitvi je bil uspešno posodobljen",
          "ERROR_MESSAGE": "Posodobitev pravilnika o dodelitvi ni uspela"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Prejeto sporočilo je bilo uspešno dodano v pravilnik",
            "ERROR_MESSAGE": "Dodajanje prejetega sporočila v pravilnik ni uspelo"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Prejeto sporočilo je bilo uspešno odstranjeno iz pravilnika",
            "ERROR_MESSAGE": "Odstranjevanje nabiralnika iz politike ni uspelo"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Ime politike:",
          "PLACEHOLDER": "Vnesite ime politike"
        },
        "DESCRIPTION": {
          "LABEL": "Opis:",
          "PLACEHOLDER": "Vnesite opis"
        },
        "STATUS": {
          "LABEL": "Status:",
          "PLACEHOLDER": "Izberite status",
          "ACTIVE": "Pravilnik je aktiven",
          "INACTIVE": "Pravilnik ni aktiven"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Vrstni red dodeljevanja",
          "ROUND_ROBIN": {
            "LABEL": "Izmenično",
            "DESCRIPTION": "Pogovore enakomerno dodeljuj agentom."
          },
          "BALANCED": {
            "LABEL": "Uravnoteženo",
            "DESCRIPTION": "Pogovore dodeljuj glede na razpoložljivo zmogljivost.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Prednost dodelitve",
          "EARLIEST_CREATED": {
            "LABEL": "Najzgodnejše ustvarjeno",
            "DESCRIPTION": "Pogovor, ki je bil ustvarjen najprej, se dodeli najprej."
          },
          "LONGEST_WAITING": {
            "LABEL": "Najdlje čakajoče",
            "DESCRIPTION": "Pogovor, ki čaka najdlje, se dodeli najprej."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Pravilen način razporejanja",
          "DESCRIPTION": "Nastavite največje število pogovorov, ki jih je mogoče dodeliti posameznemu agentu v določenem časovnem obdobju, da preprečite preobremenitev katerega koli agenta. To obvezno polje privzeto znaša 100 pogovorov na uro.",
          "INPUT_MAX": "Največ dodeli",
          "DURATION": "Pogovori na agenta v vsakem"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Dodani predali",
          "DESCRIPTION": "Dodajte predale, za katere bo ta politika veljala.",
          "ADD_BUTTON": "Dodaj poštni predal",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Išči in izberi poštne predale za dodajanje",
            "ADD_BUTTON": "Dodaj"
          },
          "EMPTY_STATE": "V to politiko ni dodanih nobenih poštnih predalov, dodajte poštni predal za začetek",
          "API": {
            "SUCCESS_MESSAGE": "Poštni predal je bil uspešno dodan politiki",
            "ERROR_MESSAGE": "Dodajanje nabiralnika v politiko ni uspelo"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Pravilo dodeljevanja je bilo uspešno izbrisano",
        "ERROR_MESSAGE": "Brisanje pravila dodeljevanja ni uspelo"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Kapaciteta agenta",
          "CREATE_POLICY": "Nova politika"
        },
        "CARD": {
          "POPOVER": "Dodani agenti",
          "EDIT": "Uredi"
        },
        "NO_RECORDS_FOUND": "Ni najdenih pravilnikov o zmogljivosti agentov"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Ustvari politiko zmogljivosti agenta"
        },
        "CREATE_BUTTON": "Ustvari politiko",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Cancel"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Description:",
          "PLACEHOLDER": "Enter description"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "Add"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Pravilnik o zmogljivosti agenta je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Brisanje pravilnika o zmogljivosti agenta ni uspelo"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Izbriši pravilnik",
      "DESCRIPTION": "Ali ste prepričani, da želite izbrisati to politiko? Tega dejanja ni mogoče razveljaviti.",
      "CONFIRM_BUTTON_LABEL": "Izbriši",
      "CANCEL_BUTTON_LABEL": "Prekliči"
    }
  }
}
